import "../../pages/recall-details.css";
import { convertInMonthNameFormat } from "../../utils/helper";
import PropTypes from "prop-types";
import { RenderRichText } from "./render-rich-text";

export const PetRecallDetails = ({
    item,
    showContainer = true,
    showRestData = true
}) => {
    const hasRichData = Boolean(item?.rich_text_enabled);

    return (
        <>
            {showContainer && (
                <div
                    style={{
                        backgroundColor: "#D5E4F0",
                        borderRadius: "10px",
                        display: "flex",
                        flexDirection: "column",
                        padding: "10px",
                        marginTop: "10px"
                    }}>
                    <h3 className="recall-summary">{item?.recall_title}</h3>
                    <div style={{ display: "flex", flexWrap: "nowrap" }}>
                        <div className="col-sm-2">
                            <div className="recall-details-card-item">
                                <span>{item?.id}</span>
                                <span>Recall ID</span>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="recall-details-card-item">
                                <span>{convertInMonthNameFormat(item?.recall_date)}</span>
                                <span>Recall Date</span>
                            </div>
                        </div>
                        <div className="col-sm-2">
                            <div className="recall-details-card-item">
                                <span>{item?.classification || 'N/A'}</span>
                                <span>Classification</span>
                            </div>
                        </div>
                        {item?.status && (
                            <div className="col-sm-2">
                                <div className="recall-details-card-item">
                                    <span>{item?.status}</span>
                                    <span>Status</span>
                                </div>
                            </div>
                        )}
                        {item?.source && (
                            <div className="col-sm-2">
                                <div className="recall-details-card-item">
                                    <span>{item?.source}</span>
                                    <span>Source</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {showRestData && (
                <>
                    {item?.recalling_firm && (
                        <div className="recall-details-body-item">
                            <h2>Recalling Firm</h2>
                            {hasRichData ? (
                                <RenderRichText text={item.recalling_firm} />
                            ) : (
                                <p>{item.recalling_firm}</p>
                            )}
                        </div>
                    )}

                    {item?.product_description && (
                        <div className="recall-details-body-item">
                            <h2>Product Description</h2>
                            {hasRichData ? (
                                <RenderRichText text={item.product_description} />
                            ) : (
                                <p>{item.product_description}</p>
                            )}
                        </div>
                    )}

                    {item?.reason_for_recall && (
                        <div className="recall-details-body-item">
                            <h2>Reason For Recall</h2>
                            {hasRichData ? (
                                <RenderRichText text={item.reason_for_recall} />
                            ) : (
                                <p>{item.reason_for_recall}</p>
                            )}
                        </div>
                    )}

                    {item?.hazard && (
                        <div className="recall-details-body-item">
                            <h2>Hazard</h2>
                            <p>{item.hazard}</p>
                        </div>
                    )}

                    {item?.remedy && (
                        <div className="recall-details-body-item">
                            <h2>Remedy</h2>
                            {hasRichData ? (
                                <RenderRichText text={item.remedy} />
                            ) : (
                                <p>{item.remedy}</p>
                            )}
                        </div>
                    )}

                    {item?.matched_keyword && (
                        <div className="recall-details-body-item">
                            <h2>Matched Keyword</h2>
                            <p>{item.matched_keyword}</p>
                        </div>
                    )}

                    {item?.report_date && (
                        <div className="recall-details-body-item">
                            <h2>Report Date</h2>
                            <p>{convertInMonthNameFormat(item.report_date)}</p>
                        </div>
                    )}

                    {item?.url && (
                        <div className="recall-details-body-item">
                            <h2>Source URL</h2>
                            <p>
                                <a href={item.url} target="_blank" rel="noreferrer">
                                    {item.url}
                                </a>
                            </p>
                        </div>
                    )}

                    {item?.image_link && (
                        <div className="recall-details-body-item">
                            <h2>Product Image</h2>
                            <div className="pet-image-container">
                                <img
                                    src={item.image_link}
                                    alt={item.product_description || "Product"}
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "400px",
                                        objectFit: "contain",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd"
                                    }}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {item?.created_on && (
                        <div className="recall-details-body-item">
                            <h2>Created On</h2>
                            <p>{new Date(item.created_on).toLocaleString()}</p>
                        </div>
                    )}

                    {item?.updated_on && (
                        <div className="recall-details-body-item">
                            <h2>Updated On</h2>
                            <p>{new Date(item.updated_on).toLocaleString()}</p>
                        </div>
                    )}
                </>
            )}
        </>
    );
};

PetRecallDetails.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        source: PropTypes.string,
        recall_title: PropTypes.string,
        recalling_firm: PropTypes.string,
        product_description: PropTypes.string,
        reason_for_recall: PropTypes.string,
        classification: PropTypes.string,
        status: PropTypes.string,
        hazard: PropTypes.string,
        remedy: PropTypes.string,
        url: PropTypes.string,
        image_link: PropTypes.string,
        recall_date: PropTypes.string,
        report_date: PropTypes.string,
        matched_keyword: PropTypes.string,
        created_on: PropTypes.string,
        updated_on: PropTypes.string,
        rich_text_enabled: PropTypes.bool
    }).isRequired,
    showContainer: PropTypes.bool,
    showRestData: PropTypes.bool
};

PetRecallDetails.defaultProps = {
    showContainer: true,
    showRestData: true
};